export const onClink = onClick => e => {
    if(e?.button === 0 && e.metaKey) {
        return
    }

    e.preventDefault()
    onClick?.()
}